import Captcha from '../class/Captcha';
import Form from '../class/Form';
import { cleanURL, getQueryParam, post, scrollToTarget } from '../utils/functions';

class Contact {
	constructor(className) {
		this.sections = document.querySelectorAll(`.${className}`);
		this.sections.forEach((section) => {
			new Section(section);
		});
	}
}

class Section {
	constructor(section) {
		return;
		// this.section = section;
		// this.controlForm();
		// try {
		// 	// this.subjects = this.getSubjects();
		// 	this.data = this.getSectionData();
		// 	this.subject = this.getSubjectFromURL();

		// 	const forms = this.section.querySelectorAll('form');
		// 	if (forms.length > 0) {
		// 		this.setCurrentSubject();
		// 		forms.forEach((form) => {
		// 			const cta = form.querySelector('a.cta');
		// 			if (cta) {
		// 				cta.classList.remove('cta--red');
		// 				cta.classList.add('cta--light-blue');
		// 			}
		// 		});
		// 	}

		// 	this.addSubjectsClickEvents();

		// 	if (getQueryParam('subject')) {
		// 		this.scrollToSubject();
		// 	}

		// 	cleanURL();
		// } catch (error) {
		// 	console.error(error);
		// }
	}

	controlForm() {
		const wpcf7Btn = document.querySelector('.wpcf7-submit');
		const wpcf7Elm = document.querySelector('.wpcf7');

		console.log(wpcf7Btn, wpcf7Elm);
		return;
		/* if (wpcf7Btn === null || wpcf7Elm === null) return;

		wpcf7Btn.addEventListener(
			'click',
			function (event) {
				document.querySelector('.wpcf7-submit').style.display = 'none';
				document.querySelector('.wpcf7-spinner').style.display = 'inline-block';
			},
			false
		);
		wpcf7Elm.addEventListener(
			'wpcf7submit',
			function (event) {
				const form = wpcf7Elm.querySelector('.wpcf7-form');
				const inputsRequired = document.querySelectorAll('.required.empty');

				if (form.classList.contains('invalid')) {
					document.querySelector('.cta-part').style.display = 'flex';
					document.querySelector('.wpcf7-submit').style.display = 'block';
					document.querySelector('.wpcf7-spinner').style.display = 'none';
					inputsRequired.forEach((inputRequired) => {
						inputRequired.classList.add('red');
					});
				} else {
					document.querySelector('.cta-part').style.display = 'none';
					document.querySelector('.wpcf7-submit').style.display = 'none';
					document.querySelector('.wpcf7-spinner').style.display = 'none';
					inputsRequired.forEach((inputRequired) => {
						inputRequired.classList.remove('red');
					});
				}
			},
			false
		); */
	}

	scrollToSubject() {
		if (this.subject) scrollToTarget(this.subject.sections, 30);
	}

	getSubjects() {
		const subjects = this.section.querySelectorAll('.contact__subject');
		if (!subjects.length) return subjects;

		return Array.prototype.slice.call(subjects).map((el) => {
			const subjectValue = el.dataset.subject;
			const allowAttachments = el.dataset.allowAttachments === '1';
			const sections = this.section.querySelector(`.contact__subject-form[data-subject="${subjectValue}"]`);

			el.removeAttribute('data-subject');
			el.removeAttribute('data-allow-attachments');

			const subject = {
				el,
				value: subjectValue,
				sections,
				allowAttachments,
				initialBackgroundColor: el.style.backgroundColor,
				initialColor: el.style.color,
			};

			if (sections) {
				sections.removeAttribute('data-subject');
				const form = sections.querySelector('form');
				if (form) {
					subject.form = form.action.includes('#sellsy-message')
						? form
						: new Form(form, {
								onSubmit: this.onSubmit,
								customValidation: this.validateSubject,
						  });
				}
			}

			return subject;
		});
	}

	getSectionData() {
		const data = this.section.dataset.sectionData;
		this.section.removeAttribute('data-section-data');
		return data ? JSON.parse(data) : null;
	}

	getSubjectFromURL() {
		if (!this.subjects) return null;

		const value = getQueryParam('subject');

		if (value) {
			const subject = this.subjects.filter((subject) => subject.value === value).shift();
			if (subject) {
				return subject;
			}
		}

		return [...this.subjects].shift();
	}

	removeCurrentSubject() {
		if (this.subject) {
			this.subject.el.style.color = this.subject.initialColor;
			this.subject.el.style.backgroundColor = this.subject.initialBackgroundColor;

			if (this.subject.sections) {
				this.subject.sections.style.display = 'none';
			}
		}
	}

	setCurrentSubject() {
		if (this.subject) {
			this.subject.el.style.color = this.subject.initialBackgroundColor;
			this.subject.el.style.backgroundColor = this.subject.initialColor;

			if (this.subject.sections) {
				this.subject.sections.style.display = 'block';
			}

			// Handle file input display
			if (this.subject.allowAttachments) {
				this.renderFileInput();
			} else if (this.fileInput) {
				this.removeFileInput();
			}
		}
	}

	addSubjectsClickEvents() {
		this.subjects.forEach((subject) => {
			if (this.data && this.data.redirectURL) {
				subject.el.addEventListener(
					'click',
					() => (window.location.href = this.data.redirectURL + `?subject=${subject.value}`)
				);
			} else {
				subject.el.addEventListener('click', this.setActiveSubject(subject));
			}
		});
	}

	setActiveSubject(subject) {
		return (ev) => {
			if (this.subject && subject.value === this.subject.value) return null;

			if (this.subject) this.removeCurrentSubject();

			this.subject = subject;
			this.setCurrentSubject();
			this.scrollToSubject();
		};
	}

	validateSubject = () => {
		if (!this.subject || !this.subject.value) {
			return 'Veuillez choisir un sujet';
		}

		return null;
	};

	onSubmit = () => {
		this.subject.form.submitButton.load();

		Captcha.submit()
			.then(() => {
				post(
					{
						form: this.subject.form.el,
						subject: this.subject.value,
						action: 'submit_contact_form',
					},
					this.onSubmitResponse,
					true
				);
			})
			.catch(() => {
				this.form.submitButton.reset();
			});
	};

	onSubmitResponse = (res) => {
		const parsedRes = JSON.parse(res);
		if (parsedRes.success) {
			this.subject.form.submitButton.success('Message envoyé !');
			this.subject.form.onSubmit = () => {};
		} else {
			this.subject.form.displayErrors(['Une erreur est survenue']);
			this.subject.form.submitButton.reset();
		}
	};

	renderFileInput() {
		const hasFileInput = this.subject.form.el.querySelector('input[type="file"]');
		if (hasFileInput) return;

		const ID = 'contact-upload';
		const uploadLabel = this.section.dataset.uploadLabel;
		const inputWrapper = document.createElement('div');
		inputWrapper.classList.add('contact__input-wrapper');

		const input = document.createElement('input');
		input.style.display = 'none';
		input.name = 'attachments';
		input.type = 'file';
		input.id = ID;

		const label = document.createElement('label');
		label.classList.add('cta');
		label.classList.add('cta--red');
		label.innerHTML = uploadLabel;
		label.htmlFor = ID;

		const fileName = document.createElement('p');
		const removeButton = document.createElement('span');
		removeButton.classList.add('contact__file-remove');

		inputWrapper.appendChild(input);
		inputWrapper.appendChild(label);
		inputWrapper.appendChild(fileName);

		input.addEventListener('change', (ev) => {
			const file = input.files[0];
			const extension = file.name.split('.').pop();
			const allowedExtensions = this.data.filetypes.replace(/\s/g, '').split(/[,|;]+/);

			if (!allowedExtensions.includes(extension)) {
				return this.subject.form.displayErrors([`Fichiers autorisés: ${allowedExtensions.join(', ').toUpperCase()}`]);
			}

			const fileSize = file.size / 1024 / 1048576;
			if (this.data.filesize < fileSize) {
				return this.subject.form.displayErrors([`Taille maximale: ${this.data.filesize}Mo`]);
			}

			fileName.innerHTML = file.name.length > 50 ? file.name.substr(0, 50) + '...' : file.name;
			fileName.appendChild(removeButton);
			removeButton.addEventListener('click', () => {
				input.value = '';
				fileName.innerHTML = '';
			});
		});

		this.fileInput = this.subject.form.el.appendChild(inputWrapper);
	}

	removeFileInput() {
		this.subject.form.el.removeChild(this.fileInput);
		this.fileInput = null;
	}
}

export default Contact;
